import React from 'react';
import { observer } from 'mobx-react';
import SettingsComponent from './Settings.component';
import useSettings from './useSettings';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { user, lang, app, state, values, handlers } = useSettings(onClose);

    return (
        <>
            <SettingsComponent
                loading={user.changeSettingsLoading}
                serverError={user.serverError}
                timezone={state.timezone}
                lang={lang.lang}
                language={state.language}
                languages={lang.languages}
                langMap={lang.langMap}
                localTimezone={values.localTimezone}
                demoModeError={app.demoModeError}
                onTimezoneChange={handlers.handleTimezoneChange}
                onSaveClick={handlers.handleSaveClick}
                onClose={onClose}
                onInputClick={handlers.handleInputClick}
                onLanguageChange={handlers.handleLanguageChange}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onSelectKeyDown={handlers.handleSelectKeyDown}
            />
        </>
    );
};

const SettingsContainer = observer(Container);

export default SettingsContainer;
